export const START_BACKTEST = "START_BACKTEST";
export const CANCEL_BACKTEST = "CANCEL_BACKTEST";
export const PREPARE_BACKTEST = "PREPARE_BACKTEST";
export const GET_BACKTES_PREVIEW = "PREPARE_BACKTEST";
export const GET_BACKTES_RESULT = "GET_BACKTES_RESULT";
export const FETCH_BACKTEST_PREVIEW = "FETCH_BACKTEST_PREVIEW";